export const FILTER_WIDGETS_TEXT = 'FILTER_WIDGETS_TEXT';

export const GET_PACK_WIDGETS = 'GET_PACK_WIDGETS';
export const RESET_PACK_WIDGETS = 'RESET_PACK_WIDGETS';
export const POST_PACK_WIDGET = 'POST_PACK_WIDGET';
export const DELETE_PACK_WIDGET = 'DELETE_PACK_WIDGET';



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/constants.js
 **/